import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpResponse } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";
import { HelperService } from "../../helper.service";
import { catchError, Observable, retry } from "rxjs";
import { OrdersModel } from "../models-otc/orders-model";
import { BaseService } from "../../services/base.service";
import { OrdersDto } from "../dto-otc/orders-dto";
import { UpdateOrderModel } from "../models-otc/udate-order-model";
import { tap } from "rxjs/operators";
import { OrderTotalsModel } from "../models-otc/order-totals-model";

@Injectable({
    providedIn: "root",
})
export class OrdersService extends BaseService {
    userId = this.helper.getUserId();
    orderId: number;
    constructor(
        private httpClient: HttpClient,
        public snackBar: MatSnackBar,
        public helper: HelperService
    ) {
        super();
    }

    //POST
    postNewOrder(representativeId?: number): Observable<number> {

            let params = new HttpParams();

             if (representativeId) {
                  params = params.append('representativeId', representativeId.toString());
              }

        return this.httpClient.post<number>(this.OTC_BASE_URL + "orders", {}, {params})
        .pipe(
            retry(0),
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open("Error Creating New Order", "close", {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
    }

    postCopyOrder(orderId: number, soldToId: number, payerId: number, representativeId?: number): Observable<number> {

        let params = new HttpParams();

          if (representativeId !== undefined) {
            params = params.append('representativeId', representativeId.toString());
        }

    return this.httpClient.post<number>(this.OTC_BASE_URL + `orders/copy/${orderId}?soldToId=${soldToId}&payerId=${payerId}`, {}, {params})
    .pipe(
        retry(0),
        catchError((err) => {
            this.hasError.next(true);
            this.snackBar.open("Error Creating New Order", "close", {
                duration: 5000,
            });
            this.hasError.next(false);
            return this.errorHandler(err);
        })
    );
}

    /// PUT ///
    updateOrderForm(ordersDto: OrdersDto): Observable<UpdateOrderModel> {
        this.orderId = ordersDto.id;
        return this.httpClient.put<UpdateOrderModel>(this.OTC_BASE_URL + `orders`, ordersDto)
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open("Error Retrieving Order Form Details", "close", {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

    updateOrderApprovalStatus(orderId: number, statusId: number): Observable<UpdateOrderModel> {
        return this.httpClient.put<UpdateOrderModel>(this.OTC_BASE_URL + `orders/${orderId}/approval?status=${statusId}`, null)
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open("Error Updating Order Status", "close", {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

    recallOrder(orderId: number): Observable<any> {
        return this.httpClient.put(this.OTC_BASE_URL + `orders/${orderId}/recall`, null);
    }

    /// GET  ///
    getOrderById(orderId: number): Observable<OrdersModel> {
        return this.httpClient
            .get<OrdersModel>(this.OTC_BASE_URL + `orders/${orderId}`)
            .pipe(
                retry(0),
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open("Error Retrieving Order Form Details", "close", {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }


    getOrderTotals(orderId: number): Observable<OrderTotalsModel> {
        return this.httpClient.get<OrderTotalsModel>(this.OTC_BASE_URL + `orders/${orderId}/totals`)
            .pipe(
                retry(0),
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open("Error Retrieving Order Form Details", "close", {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }


    getOrderReportById(orderId: number): Observable<HttpResponse<Blob>> {
        return this.httpClient.get<Blob>(this.OTC_BASE_URL + `orders/${orderId}/report`, {
          observe: 'response',
          responseType: 'blob' as 'json'
        
        }).pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open("Error Downloading Report", "close", {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            }),
            tap(() => {
                this.snackBar.open("Download Successful", "close", {
                    duration: 5000,
                });
            
            }));
        }


        getSocReportById(orderId: number): Observable<HttpResponse<Blob>> {
            return this.httpClient.get<Blob>(this.OTC_BASE_URL + `orders/${orderId}/report/soc`, {
              observe: 'response',
              responseType: 'blob' as 'json'
            
            }).pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open("Error Downloading SOC Report", "close", {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                }),
                tap(() => {
                    this.snackBar.open("SOC Download Successful", "close", {
                        duration: 5000,
                    });
                
                }));
            }

    // / DELETE ///
   
    deleteOrderById(orderId: number): Observable<string> {
        return this.httpClient.delete(this.OTC_BASE_URL + `orders/${orderId}`, { responseType: 'text'})
            .pipe(
                retry(0),
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open("Error Removing Order " + orderId, "close", {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }
}
